// CANONICAL COPY (GH #7115). src/constants/obligations/obl-secure-authentication.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-secure-authentication',
  title: 'Verify secure authentication and multi-factor authentication',
  description:
    'Confirm that secure authentication technologies are implemented, including multi-factor authentication for remote access, privileged access and administrative interfaces. Authentication information (passwords, credentials, keys) shall be allocated and managed through a formal management process covering issuance, storage, rotation and revocation. Where Entra ID is connected, MFA enforcement on privileged admin accounts is automatically verified from the synced identity posture.',
  category: 'access',
  scfIds: ['SCF-IAM-008', 'SCF-IAM-003'],
  cadence: { frequency: '6m', anchor: 'domain' },
  // SDEA-04: KNOWN VACUOUS-PASS GAP (same class as SDEA-03 / PR #6121).
  // 'privileged-mfa-enrolled' returns pass:true whenever a tenant has zero
  // Entra-synced privileged accounts — including a tenant with no Entra
  // connection at all. Under 'any', a tenant that has adopted neither a
  // published/current auth policy NOR Entra MFA tracking still passes this
  // obligation solely on that vacuous pass. Tracked as a known gap for a
  // later fix pass, not blocking this flip.
  strategy: 'any',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Authentication / MFA policy is published' },
    { type: 'document-within-sla', description: 'Policy review is not overdue' },
    // Entra-sourced: vacuous-pass when no privileged Entra accounts exist.
    {
      type: 'privileged-mfa-enrolled',
      description:
        'Every privileged Entra admin has MFA enabled (vacuous-pass if no Entra connection or no privileged accounts)',
    },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
